import {Injectable} from '@angular/core';
import {AppService} from "../app.service";
import {HEADERS, URL_API} from "../constante";
import {Response} from "@angular/http";

@Injectable()
export class PerfilService extends AppService {

    documentoUrl = URL_API + '/perfilsys';

}


// WEBPACK FOOTER //
// ./src/app/perfil/perfil.service.ts